import * as Sentry from "@sentry/browser";
import siteConfig from "site-config";

interface TransactionObject {
    transaction: ReturnType<typeof Sentry.startTransaction>;
    spans: any;
}

interface TransactionMap {
    [key: string]: TransactionObject;
}

const transactionMap: TransactionMap = {};

export function startTransaction(transactionName: string) {
    const transaction = Sentry.startTransaction({ name: transactionName });
    if (siteConfig.showConsoleTimers) {
        // eslint-disable-next-line no-console
        console.time(transactionName);
    }
    if (!transaction) {
        return;
    }
    transactionMap[transactionName] = { transaction, spans: {} };
    return transaction;
}

export function cancelTransaction(transactionName: string) {
    const transaction = transactionMap[transactionName];
    if (transaction) {
        delete transactionMap[transactionName];
        return true;
    }
    return false;
}

export function startSpan(transactionName: string, spanName: string, data?: any) {
    const transaction = transactionMap[transactionName]?.transaction;
    if (siteConfig.showConsoleTimers) {
        // eslint-disable-next-line no-console
        console.time(`${transactionName}[${spanName}]`);
    }
    if (!transaction) {
        return;
    }
    const span = transaction.startChild({ op: spanName, data });
    transactionMap[transactionName].spans = { ...transactionMap[transactionName].spans, [spanName]: span };
    return span;
}

export function finishSpan(transactionName, spanName) {
    const transactionObj = transactionMap[transactionName];
    if (siteConfig.showConsoleTimers) {
        // eslint-disable-next-line no-console
        console.timeEnd(`${transactionName}[${spanName}]`);
    }
    if (!transactionObj) {
        return;
    }
    const span = transactionObj.spans[spanName];
    if (!span) {
        return;
    }
    delete transactionObj.spans[spanName];
    return span.finish();
}

export function finishTransaction(transactionName: string) {
    const transaction = transactionMap[transactionName]?.transaction;
    if (siteConfig.showConsoleTimers) {
        // eslint-disable-next-line no-console
        console.timeEnd(transactionName);
    }
    if (!transaction) {
        return;
    }
    delete transactionMap[transactionName];
    return transaction.finish();
}
